import * as React from "react";
import { H2 } from "main/javascripts/components/atoms/H2";
import { BlockTitleStyle } from "main/javascripts/components/molecules/Lp/BlockTitle/BlockTitleStyle";

export interface IProps {
  children: any;
  styles?: any;
}

export const BlockTitle: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  return (
    <H2 styles={[BlockTitleStyle.title, props.styles]}>{props.children}</H2>
  );
};
